// extracted by mini-css-extract-plugin
export default {"optionLabel":"optionLabel---CnQyp","totalRecordsLabel":"totalRecordsLabel---a_GfO"};